import { createSelector } from "reselect";

const selectUser = (state) => state.user;

export const selectUserInfo = createSelector(selectUser, (user) =>
  user.userInfo ? user.userInfo : ""
);

export const selectUserIsLoading = createSelector(selectUser, (user) =>
  user.isLoading ? user.isLoading : ""
);

export const selectUserIsConnected = createSelector(
  selectUser,
  (user) => user?.isConnected
);

export const selectUserToken = createSelector(selectUser, (user) => user.token);
